module.exports = __webpack_public_path__ + "img/OTMS_Onboarding_HeaderAnim_RU.f8c092e9.png";